import React from 'react'
import { inject, observer } from 'mobx-react'
import { TileLayer } from 'react-leaflet'
import BingLayer from './BingLayer'
import GoogleLayer from './GoogleLayer'
import constants from 'constants.js'

const BaseLayer = ({ uiStore }) => {
  if (uiStore.baseMap === 'openStreet') {
    return (
      <TileLayer
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        key='osm'
        url='//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      />
    )
  } else if (uiStore.baseMap === 'bingRoads') {
    return (
      <BingLayer
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        key='bing-CanvasLight'
        bingMapsKey={constants.BING_KEY}
        imagerySet='CanvasLight'
      />
    )
  } else if (uiStore.baseMap === 'bingGray') {
    return (
      <BingLayer
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        key='bing-CanvasGray'
        bingMapsKey={constants.BING_KEY}
        imagerySet='CanvasGray'
      />
    )
  } else if (uiStore.baseMap === 'bingAerial') {
    return (
      <BingLayer
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        key='bing-Aerial'
        bingMapsKey={constants.BING_KEY}
        imagerySet='Aerial'
      />
    )
  } else if (uiStore.baseMap === 'bingHybrid') {
    return (
      <BingLayer
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        key='bing-aerial-with-labels'
        bingMapsKey={constants.BING_KEY}
        imagerySet='AerialWithLabels'
      />
    )
  } else if (uiStore.baseMap === 'googleRoadmap') {
    return (
      <GoogleLayer
        key={uiStore.baseMap}
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        apiKey={constants.GOOGLE_KEY}
        type='roadmap'
      />
    )
  } else if (uiStore.baseMap === 'googleSatellite') {
    return (
      <GoogleLayer
        key={uiStore.baseMap}
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        apiKey={constants.GOOGLE_KEY}
        type='satellite'
      />
    )
  } else if (uiStore.baseMap === 'googleHybrid') {
    return (
      <GoogleLayer
        key={uiStore.baseMap}
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        apiKey={constants.GOOGLE_KEY}
        type='hybrid'
      />
    )
  } else if (uiStore.baseMap === 'googleTerrain') {
    return (
      <GoogleLayer
        key={uiStore.baseMap}
        noWrap={false}
        bounds={[[-90, -180], [90, 180]]}
        apiKey={constants.GOOGLE_KEY}
        type='terrain'
      />
    )
  } else {
    throw new Error('unknown base map')
  }
}

export default inject('uiStore')(
  observer(BaseLayer)
)
